import { Ng2StateDeclaration } from '@uirouter/angular';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EmployeePayrollItemContainerComponent } from './employee-payroll-item-container';

const log = new LoggingService();

export const EmployeePayrollItemRoute: Ng2StateDeclaration = {
    // name: 'PayrollItem.**'
    name: 'employeepayrollitem',
    url: '/employeepayrollitem',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.PayrollItemModule)
    data: { requiresAuth: true },

    component: EmployeePayrollItemContainerComponent
};
